import React from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';

const DeepLinkInsightRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const insightId = searchParams.get('insightId');
  const shareCode = searchParams.get('shareCode');
  const token = localStorage.getItem('token');
  
  if (!insightId) {
    return <Navigate to="/" replace />;
  }
  
  if (token) {
    return <Navigate to={`/insightListPage?insightId=${insightId}`} replace />;
  }

  const publicUrl = shareCode  ? `/shared/insight/${insightId}/${shareCode}` : `/shared/insight/${insightId}`;
  
  return <Navigate to={publicUrl} replace />;
};

export default DeepLinkInsightRedirect;
